import React from "react";

const ContactsIcon = ({ fill = "#387CFF", stroke = "#387CFF", ...props }) => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 18 18"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    {...props} // Spread additional props (e.g., className, style)
  >
    
    <path
      d="M12 1.5V3M5.25 16.5V15C5.25 14.6022 5.40804 14.2206 5.68934 13.9393C5.97064 13.658 6.35218 13.5 6.75 13.5H11.25C11.6478 13.5 12.0294 13.658 12.3107 13.9393C12.592 14.2206 12.75 14.6022 12.75 15V16.5M6 1.5V3"
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 10.5C10.2426 10.5 11.25 9.49264 11.25 8.25C11.25 7.00736 10.2426 6 9 6C7.75736 6 6.75 7.00736 6.75 8.25C6.75 9.49264 7.75736 10.5 9 10.5Z"
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.25 3H3.75C2.92157 3 2.25 3.67157 2.25 4.5V15C2.25 15.8284 2.92157 16.5 3.75 16.5H14.25C15.0784 16.5 15.75 15.8284 15.75 15V4.5C15.75 3.67157 15.0784 3 14.25 3Z"
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ContactsIcon;
